import {defineStore} from 'pinia'
import {useBookingStore} from "../../Registration/stores/bookingStore";


export const useStepManager = defineStore('stepsManager', {
    state: () => ({
        current: null,
        steps: [],
    }),
    getters: {
        stepsWithError: state => {
          const booking = useBookingStore();
          const failingSteps = state.steps.filter((step)=>{
              const stepItems = booking._items.filter((item)=>item.step_id === step.id);
              const stepItemKeys = stepItems.map((stepItem)=>stepItem.form_mapping);
              const failingKeys = Object.keys(booking.errors);
              return stepItemKeys.filter((key)=>failingKeys.includes(key)).length > 0
          });
          return failingSteps.map(({id})=>id);
        },
        isOnLastStep: (state) => {
            return state.current.order === Math.max(...state.steps.map(({order}) => order));
        },
        canSubmit: (state) => {
            if (state.steps.length > 1) {
                return state.current.order === Math.max(...state.steps.map(({order}) => order));
            }
            return true;
        },
        canMoveNext: (state) => {
            if (state.steps.length > 1) {
                return state.current.order < Math.max(...state.steps.map(({order}) => order));
            }
            return false;
        },
        canMovePrevious: (state) => {
            if (state.steps.length > 1) {
                return state.current.order > Math.min(...state.steps.map(({order}) => order));
            }
            return false;
        },
    },
    actions: {
        initialize(steps) {
            if (steps.length > 0) {
                steps.sort((a, b) => a.order - b.order);
                steps = steps.map((step) => ({...step, validation: 'default'}));
                this.current = steps[0];
                this.steps = steps;
            }

        },
        validateCurrentStep() {
            const booking = useBookingStore();
            booking.clearErrors(this.current);
            booking.validate(false);
            const isValid = !this.stepsWithError.includes(this.current.id)
            const stepValidationStatus = isValid ? 'success' : 'error';
            this.steps = this.steps.map((step) => {
                if (step.id === this.current.id) {
                    step.validation = stepValidationStatus;
                }
                return step;
            });
            return isValid;
        },
        setCurrentStep(id) {
            this.current = this.steps.find(step => step.id === id);
        },
        next() {
            const isValid = this.validateCurrentStep();
            if (isValid) {
                const nextOrder = this.current.order + 1;
                const [nextStep] = this.steps.filter(step => step.order === nextOrder);
                if (nextStep !== undefined) {
                    this.current = nextStep;
                }
            }

        },
        async submit(status){
            const booking = useBookingStore();
            const isValid = this.validateCurrentStep(true);
            if (isValid) {
                try {
                    await booking.submit(status);
                }catch (e) {
                    console.log(e);
                }
            }
        },
        previous() {
            const isValid = this.validateCurrentStep();
            if (isValid) {
                const nextOrder = this.current.order - 1;
                const [nextStep] = this.steps.filter(step => step.order === nextOrder);
                if (nextStep !== undefined) {
                    this.current = nextStep;
                }
            }
        },
        reset(){
            this.current = this.steps[0];
        }
    }

})
